import React, { useEffect, useState } from "react";
import {
  TableRow,
  TableCell,
  Collapse,
  Box,
  Typography,
  Grid,
  Paper,
  Link,
  Button,
  makeStyles,
  TextField,
  InputAdornment,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CustomButton from "./CusomButton";
import Dropzone from "react-dropzone";
import PublishIcon from "@material-ui/icons/Publish";
import FileViewer from "./FileViewer";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../containers/actions/types";
import { presentDate } from "../functionalComponents/dataFormatFunctions";
import jwtDecode from "jwt-decode";
import DigitalSignPopupComponent from "./DigitalSignPopupComponent";
import WarningIcon from '@material-ui/icons/Warning';
import { ChevronRight } from "@material-ui/icons";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import VersionHistory from "./VersionHistory";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "16px",
    border: "1px solid #ddd",
  },
  fileLink: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  remarks: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  divider: {
    borderTop: "1px solid #ddd",
    margin: theme.spacing(1, 0),
  },
  button: {
    backgroundColor: "#FF9677",
    color: "#fff",
    marginTop: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#FF9677",
    },
  },
  dialogContent: {
    textAlign: "center",
    padding: "30px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
      fontSize: "80px",
    
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
}));

// const supportingFiles = [
//   {
//     fileName: "supporting_data.pdf",
//     fileLink: "path/to/supporting_data.pdf",
//     lastUpdatedDate: "2024-09-27 07:43:30",
//   },
// ];

const CollapsibleRow = (props) => {
  const {
    open,
    projectData,
    deliverablesData,
    row,
    workItemDetails,
    handleSuccessDialog,
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const [versionCount, setVersionCount] = useState(null);
  const [latestFile, setLatestFile] = useState(null);
  const [latestCMOFile, setLatestCMOFile] = useState(null);

  const tokenData = jwtDecode(localStorage.getItem("authToken"));

  //   const versionCount = cdmoFileDetails.length;
  //   const latestFile = sponsorFileDetails[sponsorFileDetails.length - 1];
  const [error, setError] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [cdmoFileDetails, setCdmoFileDetails] = useState([]);
  const [sponsorFileDetails, setSponsorFileDetails] = useState([]);
  const [supportingFiles, setSupportingFileDetails] = useState([]);
  const [approveClicked, setApproveClicked] = useState(false);
  const [boFiles, setBOFiles] = useState([]);
  const [recordsFound, setRecordsFound] = useState(true);
  const [viewVersionHistoryScreen, setViewVersionHistoryScreen] = useState(false);
  const [digitalSignScreen, setDigitalScreen] = useState({
    openDialogBox: false,
    envelopeId:'',
    signingUrl:''
  })
  const [openDigiSignDialogBox, setDigiSignDialogBox] = useState({
    openDialogBox: false,
    dialogBoxType: '',
    digitalSignObj: null,
  })

  const handleCloseZohoScreen = () => {
    setDigitalScreen({
      ...digitalSignScreen,
      openDialogBox: false,
      signingUrl:''
    })
  }

  const handleDigitalSignatureResponsePopup = (type,decision) => {
    setDigiSignDialogBox({
      ...openDigiSignDialogBox,
      openDialogBox: true,
      dialogBoxType: type,
      digitalSignObj:
      {
        ...openDigiSignDialogBox.digitalSignObj,
        type: decision ? decision : openDigiSignDialogBox.digitalSignObj.type ,
        }
    })
  }

  const handleViewVersionHistory = () => {
    setViewVersionHistoryScreen(!viewVersionHistoryScreen);
  };

  const handleApproveClick = () => {
    setApproveClicked(true);
  };

  useEffect(() => {
    let url = null;

    const data = {
      collabrixWorkItemID: row.collabrixWorkItemID,
      collabrixExceptionID: null,
      sponsorOrgID: deliverablesData.sponsorOrgID,
      cdmoOrgID: deliverablesData.cdmoOrgID,
    };
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDocumentDetails`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          if (
            res.data.data.cdmoFileDetails.length === 0 &&
            res.data.data.sponsorFileDetails.length === 0
          ) {
            setRecordsFound(false);
          }
          const supportingFilteredFiles = res.data.data.cdmoFileDetails.filter(
            (file) => file.fileType === "supporting_file"
          );

          setSupportingFileDetails(supportingFilteredFiles);
          const cdmoScientificFilteredFiles =
            res.data.data.cdmoFileDetails.filter(
              (file) => file.fileType === "scientific_file"
            );
          setCdmoFileDetails(cdmoScientificFilteredFiles);

          setLatestCMOFile(
            cdmoScientificFilteredFiles[cdmoScientificFilteredFiles.length - 1]
          );

          const sponsorScientificFilteredFiles =
            res.data.data.sponsorFileDetails.filter(
              (file) => file.fileType === "scientific_file"
            );

          setSponsorFileDetails(sponsorScientificFilteredFiles);
          setVersionCount(res.data.data.cdmoFileDetails.length);
          setLatestFile(
            sponsorScientificFilteredFiles[
              sponsorScientificFilteredFiles.length - 1
            ]
          );
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setError(true);
        }
      })
      .catch((err) => {
        //console.log(err);
        setIsLoading(false);
        // setError("Something went wrong. Please try again.");
        setError(true);
      });

    return () => {
      window.URL.revokeObjectURL(url);
    };
  }, []);

  const handleFileClick = (file) => {
    // Set the clicked file in the state to open the dialog
    setSelectedFile(file);
    setDialogOpen(true); // Open the dialog when a file is clicked
  };

  const handleCloseDialog = () => {
    setDialogOpen(false); // Close the dialog
  };

  const [remarks, setRemarks] = useState("");
  const [qaRemarks, setQARemarks] = useState("");

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };

  const profileDetails = useSelector((state) => state.user.userDetails || {});

  const handleCMOApproveRejectClick = (qaDecision, sequenceNumber, row,envelopeId) => {
    if (latestCMOFile) {
      let data = {
        ...latestCMOFile,
        projectName: deliverablesData.projectName,
        sponsorOrgID: deliverablesData.sponsorOrgID,
        cdmoOrgID: deliverablesData.cdmoOrgID,
        qaDecision: qaDecision,
        activeOrderId: sequenceNumber,
        envelopeId: envelopeId ? envelopeId: null,
        approvalDataQAandSME: latestCMOFile.approvalDataQAandSME.map((val) => {
          if (sequenceNumber === val.sequenceNumber) {
            return {
              ...val,
              decision: qaDecision,
              remarks: remarks,
            };
          } else {
            return val;
          }
        }),
      };
      //console.log(data);
      if (row.eSignatureRequired) {
        handleSuccessDialog("verifyElectronicSignature", data);
      } else {
        setDigiSignDialogBox({
          openDialogBox: false,
          dialogBoxType: '',
          digitalSignObj: null,
        })
        dispatch({
          type: OPEN_BACKDROP,
        });
        const url = `${appUrl}/${localStorage.appName}/${
          localStorage.network
        }/${localStorage.collabType}/workflow/${
          qaDecision === "Approved" ? "approval" : "reject"
        }`;
        // console.log(url)
        // console.log(data)
        axios
          .post(url, data)
          .then((res) => {
            dispatch({
              type: DESTROY_BACKDROP,
            });
            if (res.data.status) {
              if (qaDecision === "Approved") {
                handleSuccessDialog("documentApproved");
              } else {
                handleSuccessDialog("documentRejected");
              }
            } else {
              dispatch({
                type: DESTROY_BACKDROP,
              });
              setError(true);
            }
          })
          .catch((err) => {
            dispatch({
              type: DESTROY_BACKDROP,
            });
            //console.log(err);
            setError(true);
          });
      }

      // dispatch({
      //   type: OPEN_BACKDROP,
      // });
      // setTimeout(() => {
      //   dispatch({
      //     type: DESTROY_BACKDROP,
      //   });
      //   handleSuccessDialog("verifyElectronicSignature", data);
      // }, [3000]);
    }
  };

  //console.log(latestCMOFile);
  // console.log(
  //   latestCMOFile?.approvalDataQAandSME.filter(
  //     (val) =>
  //       val.userId !== deliverablesData.sponsorQASignatoryID &&
  //       val.decisionBy === tokenData.email_address &&
  //       val.stakeHolderType === "External" &&
  //       val.requirementType === "Approve" &&
  //       (val.decision === "" || val.decision === null)
  //   )
  // );

  const getDigitalSigingUrl = (sequenceNumber, collabrixFileID) => {
    // dispatch({
    //   type: OPEN_BACKDROP,
    // });
    setIsLoading(true)
    const url = `${appUrl}/${localStorage.appName}/${
      localStorage.network
      }/${localStorage.collabType}/workflow/signing-url/${sequenceNumber}/${collabrixFileID}`;
    
    // console.log(url)
    axios
      .get(url)
      .then((res) => {
        // dispatch({
        //   type: DESTROY_BACKDROP,
        // });
        setIsLoading(false)
        // console.log(res)
        if (res.data.status) {
          //console.log('setDigitalScreen open true')
          //console.log(res.data.envelopeId)
          //console.log(res.data.signingUrl)
          setDigitalScreen({
            openDialogBox: true,
            envelopeId: res.data.envelopeId,
            signingUrl: res.data.signingUrl
          })
        } else {
          // dispatch({
          //   type: DESTROY_BACKDROP,
          // });
          setDigiSignDialogBox({
            ...openDigiSignDialogBox,
            openDialogBox: true,
            dialogBoxType: 'failed',
          })
        }
      })
      .catch((err) => {
        setDigiSignDialogBox({
          ...openDigiSignDialogBox,
          openDialogBox: true,
          dialogBoxType: 'failed',
        })
        setIsLoading(false)
        // dispatch({
        //   type: DESTROY_BACKDROP,
        // });
        //console.log(err);
      });
  }

  return (
    <>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                  height: "100px", // Optional: Set a height to vertically center the loader
                }}
              >
                <CircularProgress />
              </div>
            ) : error ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                  height: "100px", // Optional: Set a height to vertically center the loader
                  border: "2px solid #FF0000",
                  backgroundColor: "#FFF0F0",
                  width: "100%",
                }}
              >
                <Typography style={{ textAlign: "center" }}>
                  Something went wrong. Please try again.
                </Typography>
              </div>
            ) : recordsFound ? (
              <Box margin={1}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Typography variant="h6">
                      {deliverablesData.cdmoOrgName}
                    </Typography>
                    <Paper elevation={2} className={classes.paper}>
                      {cdmoFileDetails.map((file, index) => (
                        <React.Fragment key={index}>
                          <Grid container spacing={3}>
                            {/* Version and Date (Left-aligned) */}
                            <Grid item xs={4}>
                              <Typography variant="subtitle1">
                                Version {file.versionNumber}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                {moment(file.lastUpdatedDate).format(
                                  "(YYYY-MM-DD HH:mm:ss)"
                                )}
                              </Typography>
                            </Grid>

                            {/* File Name (Right-aligned) */}
                            <Grid item xs={8} className={classes.fileLink}>
                              <PublishIcon className={classes.icon} />
                              <Link
                                href={file.fileLink}
                                target="_blank"
                                rel="noopener"
                                color="secondary"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent default link action
                                  handleFileClick(file); // Trigger the state change to open the component
                                }}
                              >
                                {file.fileName}
                              </Link>
                            </Grid>
                          </Grid>

                          {/* Remarks (Upload or Resubmission) */}
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              {index === 0 && versionCount === 1 ? (
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Upload Remarks
                                </Typography>
                              ) : index > 0 ? (
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Resubmission Remarks
                                </Typography>
                              ) : (
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Upload Remarks
                                </Typography>
                              )}
                            </Grid>
                            <Grid item xs={8}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                {file.uploadRemarks
                                  ? file.uploadRemarks
                                  : "-NA-"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      ))}

                      {/* Add "Remind Sponsor Team" button */}
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Grid
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              paddingTop: "14px",
                            }}
                          >
                            <CustomButton
                              color="#F26336" // Custom orange background
                              hoverColor="#D8542E" // Darker orange on hover
                              textColor="#fff" // Explicitly set white text color
                              disabled
                              //   disabled={
                              //     localStorage.collabType === "Pharma Co"
                              //       ? true
                              //       : false
                              //   }
                            >
                              Remind Sponsor Team
                            </CustomButton>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <div className={classes.divider}></div>
                        </Grid>
                      </Grid>

                      {/* Supporting Files */}
                      <Grid container spacing={3}>
                        {supportingFiles.map((file, index) => (
                          <>
                            <Grid item xs={4}>
                              <Typography
                                variant="subtitle1"
                                style={{ marginTop: "20px" }} // Added margin for better spacing
                              >
                                {index === 0 ? "Supporting Files" : ""}
                              </Typography>
                            </Grid>

                            <Grid
                              container
                              item
                              xs={8}
                              key={index}
                              alignItems="flex-start"
                              className={classes.fileLink}
                              style={{ marginTop: "20px" }} // Added margin for better spacing
                            >
                              {/* File Icon and Name */}
                              <Grid container alignItems="center">
                                <PublishIcon className={classes.icon} />
                                <Link
                                  href={file.fileLink}
                                  target="_blank"
                                  rel="noopener"
                                  style={{
                                    marginRight: "8px",
                                    cursor: "pointer",
                                  }}
                                  color="secondary"
                                  onClick={(e) => {
                                    e.preventDefault(); // Prevent default link action
                                    handleFileClick(file); // Trigger the state change to open the component
                                  }}
                                >
                                  {file.fileName}
                                </Link>
                              </Grid>

                              {/* Date below the file name */}
                              <Grid item xs={12}>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                >
                                  {moment(file.lastUpdatedDate).format(
                                    "(YYYY-MM-DD HH:mm:ss)"
                                  )}
                                </Typography>
                              </Grid>
                            </Grid>
                          </>
                        ))}
                      </Grid>
                        </Paper>
                        {/* <Grid
                      container
                      item
                      justifyContent="flex-start"
                      style={{ marginTop: "1rem" }}
                    >
                      <CustomButton
                        hasBorder={true}
                        style={{ marginLeft: "8px" }} // Add margin to separate the buttons
                        onClick={handleViewVersionHistory}
                      >
                        View versions history
                      </CustomButton>
                    </Grid> */}
                  </Grid>

                  {latestFile ? (
                    <Grid item xs={6}>
                      <Typography variant="h6">
                        {deliverablesData.sponsorOrgName}
                      </Typography>
                      <Paper elevation={2} className={classes.paper}>
                        {sponsorFileDetails.map((file, index) => (
                          <React.Fragment key={index}>
                            <Grid container spacing={3}>
                              <Grid item xs={5}>
                                <Typography variant="subtitle1">
                                  Response to Version {file.versionNumber}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                >
                                  {moment(file.lastUpdatedDate).format(
                                    "(YYYY-MM-DD HH:mm:ss)"
                                  )}
                                </Typography>
                              </Grid>

                              <Grid item xs={7} className={classes.fileLink}>
                                <PublishIcon className={classes.icon} />
                                <Link
                                  href={file.fileLink}
                                  target="_blank"
                                  rel="noopener"
                                  color="secondary"
                                  style={{ cursor: "pointer" }}
                                  onClick={(e) => {
                                    e.preventDefault(); // Prevent default link action
                                    handleFileClick(file); // Trigger the state change to open the component
                                  }}
                                >
                                  {file.fileName}
                                </Link>
                              </Grid>
                            </Grid>

                            <Grid container spacing={3}>
                              <Grid item xs={5}>
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Upload Remarks
                                </Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  {file.uploadRemarks
                                    ? file.uploadRemarks
                                    : "NA"}
                                </Typography>
                              </Grid>
                            </Grid>
                          </React.Fragment>
                        ))}

                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <Grid
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                paddingTop: "14px",
                              }}
                            >
                              <CustomButton
                                color="#F26336" // Custom orange background
                                hoverColor="#D8542E" // Darker orange on hover
                                textColor="#fff" // Explicitly set white text color
                                disabled
                                //   disabled={
                                //     localStorage.collabType === "Pharma Co"
                                //       ? true
                                //       : false
                                //   }
                              >
                                Remind CMO Team
                              </CustomButton>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  ) : (
                    <Grid item xs={6}>
                      <Typography variant="h6">
                        {deliverablesData.sponsorOrgName}
                      </Typography>
                      <Paper elevation={2} className={classes.paper}>
                        {/* {sponsorFileDetails.map((file, index) => (
                        <React.Fragment key={index}>
                          <Grid container spacing={3}>
                            <Grid item xs={5}>
                              <Typography variant="subtitle1">
                                Version {file.versionNumber} (with edits)
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                {moment(file.lastUpdatedDate).format(
                                  "(YYYY-MM-DD HH:mm:ss)"
                                )}
                              </Typography>
                            </Grid>

                            <Grid item xs={7} className={classes.fileLink}>
                              <PublishIcon className={classes.icon} />
                              <Link
                                href={file.fileLink}
                                target="_blank"
                                rel="noopener"
                                color="secondary"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent default link action
                                  handleFileClick(file); // Trigger the state change to open the component
                                }}
                              >
                                {file.fileName}
                              </Link>
                            </Grid>
                          </Grid>

                          <Grid container spacing={3}>
                            <Grid item xs={5}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                Approve / Reject Remarks
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                {file.uploadRemarks}
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      ))} */}

                        {/* Conditionally render the upload section if the latest file is rejected */}
                        {/* {localStorage.collabType === "Pharma Co" && (
                        <Grid
                          container
                          spacing={3}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Grid item xs={5}>
                            {!approveClicked ? (
                              <CustomButton
                                color="#F26336" // Custom orange background
                                hoverColor="#D8542E" // Darker orange on hover
                                textColor="#fff" // Explicitly set white text color
                                fontSize="0.275rem"
                              >
                                {`Upload Version ${
                                  latestFile ? latestFile.versionNumber + 1 : 1
                                } (with edits)`}
                              </CustomButton>
                            ) : (
                              <Typography>{`Version ${
                                latestFile ? latestFile.versionNumber + 1 : 1
                              } (with edits)`}</Typography>
                            )}
                          </Grid>

                          <Grid item xs={7}>
                            {!approveClicked ? (
                              <Dropzone
                                disabled
                                accept=".csv,.xls,.xlsx,.pdf,.jpeg,.png,.jpg,.bmp,.doc,.docx"
                              >
                                {({ getRootProps, getInputProps }) => (
                                  <div
                                    {...getRootProps({
                                      className: "dropzone",
                                      onDrop: (event) => event.preventDefault(),
                                    })}
                                    // className={classes.files}
                                    style={{
                                      border: "1px solid #707070",
                                      display: "flex",
                                      alignItems: "center", // Align content vertically
                                      justifyContent: "space-between", // Space out text and icon
                                      //   padding: "10px",
                                    }}
                                  >
                                    <input {...getInputProps()} />

                                    <Typography
                                      variant="body2"
                                      style={{
                                        cursor: "pointer",
                                        paddingLeft: "10px",
                                      }}
                                    >
                                      Drag &amp; drop or click here to upload
                                      files
                                    </Typography>

                                    <PublishIcon
                                      fontSize="large"
                                      style={{
                                        marginLeft: "auto", // Push icon to the right
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>
                                )}
                              </Dropzone>
                            ) : (
                              <Typography>-NA-</Typography>
                            )}
                          </Grid>
                        </Grid>
                      )}

                      {localStorage.collabType === "Pharma Co" && (
                        <Grid
                          container
                          spacing={3}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Grid item xs={5}>
                            <Typography
                              variant="body2"
                              className={classes.remarks}
                            >
                              Approve / Reject Remarks
                            </Typography>
                          </Grid>
                          <Grid item xs={7}>
                            {!approveClicked ? (
                              <TextField
                                placeholder="Enter remarks here"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                multiline
                                size="small"
                                value={remarks} // Bind the state to the TextField value
                                // onChange={handleRemarksChange} // Trigger the handler on change
                              />
                            ) : (
                              <Typography>
                                {remarks ? remarks : "-NA-"}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      )}


                      {!approveClicked &&
                        localStorage.collabType === "Pharma Co" && (
                          <Grid
                            container
                            spacing={3}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Grid item xs={5}></Grid>
                            <Grid item xs={7}>
                              <Grid
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomButton
                                  color="#28A745"
                                  textColor="#fff"
                                  onClick={handleApproveClick}
                                >
                                  Approve
                                </CustomButton>

                                <CustomButton color="#DC3545" textColor="#fff">
                                  Reject
                                </CustomButton>
                                <CustomButton
                                  color="#F26336" // Custom orange background
                                  hoverColor="#D8542E" // Darker orange on hover
                                  textColor="#fff"
                                >
                                  Remind CDMO Team
                                </CustomButton>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                      {approveClicked &&
                        localStorage.collabType === "Pharma Co" && (
                          <Grid
                            container
                            spacing={3}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Grid item xs={5}>
                              <Typography>Approved By</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography>
                                {profileDetails.full_name} on{" "}
                                {moment().format("DD-MM-YYYY")}
                              </Typography>
                            </Grid>
                          </Grid>
                        )}

                      {row.qaApprovalRequired &&
                        localStorage.collabType === "Pharma Co" && (
                          <>
                            <Grid container spacing={3}>
                              <Grid xs={12}>
                                <div className={classes.divider}></div>
                              </Grid>
                            </Grid>

                            <Grid
                              container
                              spacing={3}
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Grid item xs={5}>
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  QA Approval
                                </Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <TextField
                                  placeholder="Enter remarks here"
                                  variant="outlined"
                                  fullWidth
                                  margin="normal"
                                  // multiline
                                  size="small"
                                  value={qaRemarks} // Bind the state to the TextField value
                                />
                              </Grid>
                            </Grid>

                            <Grid
                              container
                              spacing={3}
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Grid item xs={5}></Grid>
                              <Grid item xs={7}>
                                <Grid
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <CustomButton
                                    color="#28A745"
                                    textColor="#fff"
                                    disabled={!approveClicked}
                                  >
                                    Approve
                                  </CustomButton>

                                  <CustomButton
                                    color="#DC3545"
                                    textColor="#fff"
                                    disabled={!approveClicked}
                                  >
                                    Reject
                                  </CustomButton>
                                  <CustomButton
                                    color="#F26336" // Custom orange background
                                    hoverColor="#D8542E" // Darker orange on hover
                                    textColor="#fff"
                                    disabled={!approveClicked}
                                  >
                                    Remind CDMO Team
                                  </CustomButton>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        )} */}

                        {latestCMOFile &&
                          // latestCMOFile.qaDecision !== "" &&
                          latestCMOFile?.approvalDataQAandSME.filter(
                            (val) =>
                              val.stakeHolderType === "External" &&
                              val.requirementType === "Approve" &&
                              (val.decision === "Approved" ||
                                val.decision === "Rejected")
                          ).length > 0 &&
                          localStorage.collabType === "Pharma Co" &&
                          latestCMOFile?.approvalDataQAandSME
                            .filter(
                              (val) =>
                                val.stakeHolderType === "External" &&
                                val.userId !==
                                  deliverablesData.sponsorQASignatoryID &&
                                val.requirementType === "Approve" &&
                                (val.decision === "Approved" ||
                                  val.decision === "Rejected")
                            )
                            .map((val) => (
                              <>
                                <Grid container spacing={3}>
                                  <Grid item xs={4}>
                                    <Typography
                                      variant="body2"
                                      className={classes.remarks}
                                    >
                                      Supporting files
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={8}>
                                    <Typography
                                      variant="body2"
                                      className={classes.remarks}
                                    >
                                      NA
                                    </Typography>
                                  </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                  <Grid item xs={4}>
                                    <Typography
                                      variant="body2"
                                      className={classes.remarks}
                                    >
                                      Approve/Reject Remarks
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={8}>
                                    <Typography
                                      variant="body2"
                                      className={classes.remarks}
                                    >
                                      {val?.docusignRemarks && val?.docusignRemarks !=='' ? val?.docusignRemarks : val?.remarks && val?.remarks !== ""
                                              ? val?.remarks
                                              : "NA"}
                                    </Typography>
                                  </Grid>
                                </Grid>

                                <Grid container spacing={3}>
                                  <Grid item xs={4}>
                                    <Typography
                                      variant="body2"
                                      className={classes.remarks}
                                    >
                                      {val?.decision === "Approved"
                                        ? "Approved by"
                                        : "Rejected by"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={8}>
                                    <Typography
                                      variant="body2"
                                      className={classes.remarks}
                                    >
                                      {val?.docusignRemarks && val?.docusignRemarks !== '' ?
                                                      `${val?.userName} on ${val?.decisionDate ? moment(val?.decisionDate).format("DD-MMM-YYYY"):' - '} in Docusign (though initially approved in Mosymphony)`
                                                      :`${val?.userName} on ${val?.decisionDate ? moment(val?.decisionDate).format("DD-MMM-YYYY"):' - '}`}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </>
                            ))}

                        {latestCMOFile &&
                          // latestCMOFile.qaDecision === "" &&
                          latestCMOFile?.approvalDataQAandSME.filter(
                            (val) =>
                              val.stakeHolderType === "External" &&
                              val.requirementType === "Approve" &&
                              (val.decision === "" || val.decision === null)
                          ).length > 0 &&
                          localStorage.collabType === "Pharma Co" &&
                          latestCMOFile?.approvalDataQAandSME
                            .filter(
                              (val) =>
                                val.userId !==
                                  deliverablesData.sponsorQASignatoryID &&
                                val.stakeHolderType === "External" &&
                                val.requirementType === "Approve" &&
                                (val.decision === "" || val.decision === null)
                            )
                            .map((val) => (
                              <React.Fragment>
                                <Grid
                                  container
                                  spacing={3}
                                  // style={{ display: "flex", alignItems: "center" }}
                                >
                                  <Grid item xs={4}>
                                    <Typography
                                      variant="body2"
                                      className={classes.remarks}
                                    >
                                      Supporting files
                                    </Typography>
                                  </Grid>

                                  {/* Drag & Drop file area */}

                                  {boFiles.length === 0 ? (
                                    <Grid item xs={8}>
                                      <Box>
                                        <Dropzone
                                          disabled
                                          // onDrop={(files) => {
                                          //   handleFileUpload(files);
                                          // }}
                                          accept=".pdf"
                                        >
                                          {({
                                            getRootProps,
                                            getInputProps,
                                          }) => (
                                            <div
                                              {...getRootProps({
                                                className: "dropzone",
                                                onDrop: (event) =>
                                                  event.preventDefault(),
                                              })}
                                              // className={classes.files}
                                              style={{
                                                border: "1px solid #707070",
                                                display: "flex",
                                                alignItems: "center", // Align content vertically
                                                justifyContent: "space-between", // Space out text and icon
                                                //   padding: "10px",
                                              }}
                                            >
                                              <input {...getInputProps()} />

                                              {/* Text for the dropzone */}
                                              <Typography
                                                variant="body2"
                                                style={{
                                                  cursor: "pointer",
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                Drag &amp; drop or click here to
                                                upload files
                                              </Typography>

                                              {/* Upload icon aligned to the right */}
                                              <PublishIcon
                                                fontSize="large"
                                                style={{
                                                  marginLeft: "auto", // Push icon to the right
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </div>
                                          )}
                                        </Dropzone>
                                        <Typography variant="caption">
                                    <span style={{ color: "red" }}>Note:</span>{" "}
                                    Only PDF files are allowed
                                  </Typography>
                                      </Box>
                                    </Grid>
                                  ) : (
                                    <Grid
                                      item
                                      xs={8}
                                      className={classes.fileLink}
                                    >
                                      {boFiles.map((file, i) => (
                                        <>
                                          <PublishIcon
                                            className={classes.icon}
                                          />
                                          <Link
                                            // href={file.fileLink}
                                            target="_blank"
                                            color="secondary"
                                            style={{ cursor: "pointer" }}
                                            // onClick={(e) => {
                                            //   e.preventDefault(); // Prevent default link action
                                            //   handleFileClick(file); // Trigger the state change to open the component
                                            // }}
                                          >
                                            {file.name}
                                          </Link>
                                          {/* <CloseIcon
                                        fontSize="small"
                                        color="error"
                                        style={{
                                          paddingLeft: "0.5rem",
                                          paddingTop: "0.5rem",
                                          cursor: "pointer",
                                          width: "19px",
                                        }}
                                        onClick={() => handleFileDelete(i)}
                                      /> */}
                                        </>
                                      ))}
                                    </Grid>
                                  )}
                                </Grid>
                                <Grid
                                  container
                                  spacing={3}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Grid item xs={4}>
                                    <Typography
                                      variant="body2"
                                      className={classes.remarks}
                                    >
                                      Approve/Reject Remarks
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={8}>
                                    <TextField
                                      placeholder="Enter remarks here"
                                      variant="outlined"
                                      fullWidth
                                      margin="normal"
                                      multiline
                                      size="small"
                                      disabled={
                                        val.decisionBy !==
                                          tokenData.email_address ||
                                        (val.decisionBy ===
                                          tokenData.email_address &&
                                          val.enableApprovalFlag === false)
                                      }
                                      value={
                                        val.decisionBy !==
                                          tokenData.email_address ||
                                        (val.decisionBy ===
                                          tokenData.email_address &&
                                          val.enableApprovalFlag === false)
                                          ? ""
                                          : remarks
                                      }
                                      onChange={handleRemarksChange} // Trigger the handler on change
                                      onBlur={(e) => {
                                        const { name, value } = e.target;
                                        // Trim leading and trailing spaces for string values
                                        if (typeof value === "string" && value.trim() !== value) {
                                          handleRemarksChange({ target: { name, value: value.trim() } });
                                        }
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                                <Grid
                                  container
                                  spacing={3}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Grid item xs={4}></Grid>
                                  <Grid item xs={8}>
                                    <Grid
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <CustomButton
                                        color="#28A745"
                                        textColor="#fff"
                                        disabled={
                                          val.decisionBy !==
                                            tokenData.email_address ||
                                          (val.decisionBy ===
                                            tokenData.email_address &&
                                            val.enableApprovalFlag === false)
                                        }
                                        onClick={() => {
                                          if (val.eSignatureRequired) {
                                            handleCMOApproveRejectClick(
                                              "Approved",
                                              val.sequenceNumber,
                                              val
                                            )
                                          } else if (val.digitalSignatureRequired) {
                                            getDigitalSigingUrl(val.sequenceNumber,latestCMOFile.collabrixFileID)
                                            // setDigitalScreen({
                                            //   openDialogBox: true,
                                            //   // signingUrl: val.signingUrl
                                            //   signingUrl: 'https://demo.docusign.net/Signing/MTRedeem/v1/bba66182-881e-4421-8228-8aa44d363fbd?slt=eyJ0eXAiOiJNVCIsImFsZyI6IlJTMjU2Iiwia2lkIjoiNjgxODVmZjEtNGU1MS00Y2U5LWFmMWMtNjg5ODEyMjAzMzE3In0.AQYAAAABAAMABwCAnyHjxBLdSAgAgD8zauYS3UgYAAEAAAAAAAAAIQDsAgAAeyJUb2tlbklkIjoiYzMyZjkwZDAtOGYyMy00MzZhLWFlNTctN2Q1MDgxZGRkZjAxIiwiRXhwaXJhdGlvbiI6IjIwMjQtMTItMDJUMTE6MzY6MzkrMDA6MDAiLCJJc3N1ZWRBdCI6IjIwMjQtMTItMDJUMTE6MzE6MzkuMTU1NjM3NSswMDowMCIsIlJlc291cmNlSWQiOiJjMDJhOTI0OS00NjExLTRkYTUtYTVjYi1kNWU5NzkwMWJjNjIiLCJSZXNvdXJjZXMiOiJ7XCJFbnZlbG9wZUlkXCI6XCJjMDJhOTI0OS00NjExLTRkYTUtYTVjYi1kNWU5NzkwMWJjNjJcIixcIkFjdG9yVXNlcklkXCI6XCIyYmNkZGM1Yi1iZDg2LTRhZGEtYmIyMy1mNGUzOGU3MGQ0NTBcIixcIlJlY2lwaWVudElkXCI6XCI0ZDQwNDNkMC1hZGFmLTQwMDAtYjc0OC1hYjg5ODgzMTBiMDZcIixcIkZha2VRdWVyeVN0cmluZ1wiOlwidD02YWRlNGY1YS0xNzcyLTRmNzctYmM2OS0xNjUwMjc1MDEyNmZcIixcIkludGVncmF0b3JLZXlcIjpcImY0M2RlN2JkLWZjZDgtNGExZS05YTY2LTFiMzFhYTZlYWNjMlwiLFwiQ3JlYXRlZEF0XCI6XCIyMDI0LTEyLTAyVDExOjMxOjM5LjE0ODYzNTlaXCJ9IiwiVG9rZW5UeXBlIjoxLCJBdWRpZW5jZSI6IjI1ZTA5Mzk4LTAzNDQtNDkwYy04ZTUzLTNhYjJjYTU2MjdiZiIsIlJlZGlyZWN0VXJpIjoiaHR0cHM6Ly9kZW1vLmRvY3VzaWduLm5ldC9TaWduaW5nL1N0YXJ0SW5TZXNzaW9uLmFzcHgiLCJIYXNoQWxnb3JpdGhtIjowLCJIYXNoUm91bmRzIjowLCJUb2tlblN0YXR1cyI6MCwiSXNTaW5nbGVVc2UiOmZhbHNlfT8AAGdZlcUS3Ug.D4EteV3mpOHS1tHzwvBZlXSpx6jfsSGTXXpCnfV4dzAk252liAHLndFgEqlipx2992UORt-NG4031BjFRc06L_oYJ_MvGxGrotopXR41TtJjV4lBoqpoCfh6IStEtbyC8tDl88N5Y2i8OO2YwA66I5mxMXvbvhApFBkrbA56dNSYQU0EwxU0VTinlGtrBf8FKr17JdbHAKFVczsNpxu5UWp7hEf2WqIPD1W2kFfkL1fyrKsWg2aHwcbpPWBf5CkGEXeGtC8tnIyvNa3www2hQJcEvsYtNSQwlhaTeVZybgqiBgCHohx7tCxMhP31BEwS-uDx0s6TQpzLgZVPmc7rDw'
                                            // })
                                                          setDigiSignDialogBox({
                                                            ...openDigiSignDialogBox,
                                                            digitalSignObj:
                                                            {
                                                              type: "Approved",
                                                              value: val
                                                              }
                                                          })
                                          } else {
                                            handleCMOApproveRejectClick(
                                              "Approved",
                                              val.sequenceNumber,
                                              val
                                            )
                                          }
                                          
                                        }
                                        }
                                        // onClick={() => handleCMOApproveRejectClick("Approved")}
                                      >
                                        Approve
                                      </CustomButton>

                                      <CustomButton
                                        color="#DC3545"
                                        textColor="#fff"
                                        disabled={
                                          val.decisionBy !==
                                            tokenData.email_address ||
                                          (val.decisionBy ===
                                            tokenData.email_address &&
                                            val.enableApprovalFlag === false)
                                        }
                                        onClick={() => {
                                          if (val.eSignatureRequired) {
                                            // handleCMOApproveRejectClick(
                                            //   "Rejected",
                                            //   val.sequenceNumber,
                                            //   val
                                            // )
                                            setDigiSignDialogBox({
                                              ...openDigiSignDialogBox,
                                              openDialogBox: true,
                                              dialogBoxType: 'success',
                                              digitalSignObj:
                                              {
                                                type: "Rejected",
                                                value: val
                                                }
                                            })
                                          } else if (val.digitalSignatureRequired) {
                                            // handleCMOApproveRejectClick(
                                            //   "Rejected",
                                            //   val.sequenceNumber,
                                            //   val
                                            // )
                                            // getDigitalSigingUrl(val.sequenceNumber,latestCMOFile.collabrixFileID)
                                            // setDigiSignDialogBox({
                                            //   ...openDigiSignDialogBox,
                                            //   digitalSignObj:
                                            //   {
                                            //     type: "Rejected",
                                            //     value: val
                                            //     }
                                            // })
                                            setDigiSignDialogBox({
                                              ...openDigiSignDialogBox,
                                              openDialogBox: true,
                                              dialogBoxType: 'success',
                                              digitalSignObj:
                                              {
                                                type: "Rejected",
                                                value: val
                                                }
                                            })
                                          } else {
                                            // handleCMOApproveRejectClick(
                                            //   "Rejected",
                                            //   val.sequenceNumber,
                                            //   val
                                            // )
                                            setDigiSignDialogBox({
                                              ...openDigiSignDialogBox,
                                              openDialogBox: true,
                                              dialogBoxType: 'success',
                                              digitalSignObj:
                                              {
                                                type: "Rejected",
                                                value: val
                                                }
                                            })
                                          }
                                        }
                                        }
                                        // onClick={() => handleCMOApproveRejectClick("Rejected")}
                                      >
                                        Reject
                                      </CustomButton>
                                      <CustomButton
                                        color="#F26336" // Custom orange background
                                        hoverColor="#D8542E" // Darker orange on hover
                                        textColor="#fff"
                                        disabled
                                      >
                                        Remind CMO Team
                                      </CustomButton>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </React.Fragment>
                            ))}

                        {/* {latestCMOFile &&
                             latestCMOFile?.approvalDataQAandSME.filter((val)=>  val.stakeHolderType === "External" && val.requirementType === "Approve" && (val.decision==='' ||val.decision===null )).length > 0 &&
                            localStorage.collabType === "Pharma Co" &&
                            <>
                            {latestCMOFile?.approvalDataQAandSME.filter((val) =>  val.stakeHolderType === "External" && val.userId !== deliverablesData.sponsorQASignatoryID && val.requirementType === "Approve" && (val.decision === '' || val.decision === null)).map((val) => (
                              val.decisionBy === tokenData.email_address && val.enableApprovalFlag === true ?
                                <></>
                                :
                                
                              <Grid container spacing={3}>
                              <Grid item xs={4}>
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  {val.requirementType === "Approve" ? 'Approval':'Review'}
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                  >
                                    {val.enableApprovalFlag ? `Assigned to ${val.userName} ( ${val.userRole} )`:`To be assigned to ${val.userName} ( ${val.userRole} )`}
                                </Typography>
                              </Grid>
                                  </Grid>
                            ))
                            
                      }

                            </>} */}

                        {row.qaApprovalRequired &&
                          localStorage.collabType === "Pharma Co" && (
                            <>
                              <Grid container spacing={3}>
                                <Grid xs={12}>
                                  <div className={classes.divider}></div>
                                </Grid>
                              </Grid>

                              {latestCMOFile &&
                                // latestCMOFile.qaDecision !== "" &&
                                latestCMOFile?.approvalDataQAandSME.filter(
                                  (val) =>
                                    val.stakeHolderType === "External" &&
                                    val.requirementType === "Approve" &&
                                    (val.decision === "Approved" ||
                                      val.decision === "Rejected")
                                ).length > 0 &&
                                localStorage.collabType === "Pharma Co" &&
                                latestCMOFile?.approvalDataQAandSME
                                  .filter(
                                    (val) =>
                                      val.stakeHolderType === "External" &&
                                      val.userId ===
                                        deliverablesData.sponsorQASignatoryID &&
                                      val.requirementType === "Approve" &&
                                      (val.decision === "Approved" ||
                                        val.decision === "Rejected")
                                  )
                                  .map((val) => (
                                    <>
                                      <Grid container spacing={3}>
                                        <Grid item xs={4}>
                                          <Typography
                                            variant="body2"
                                            className={classes.remarks}
                                          >
                                            Supporting files
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                          <Typography
                                            variant="body2"
                                            className={classes.remarks}
                                          >
                                            NA
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                      <Grid container spacing={3}>
                                        <Grid item xs={4}>
                                          <Typography
                                            variant="body2"
                                            className={classes.remarks}
                                          >
                                            Approve/Reject Remarks
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                          <Typography
                                            variant="body2"
                                            className={classes.remarks}
                                          >
                                            {val?.docusignRemarks && val?.docusignRemarks !=='' ? val?.docusignRemarks : val?.remarks && val?.remarks !== ""
                                              ? val?.remarks
                                              : "NA"}
                                          </Typography>
                                        </Grid>
                                      </Grid>

                                      <Grid container spacing={3}>
                                        <Grid item xs={4}>
                                          <Typography
                                            variant="body2"
                                            className={classes.remarks}
                                          >
                                            {val?.decision === "Approved"
                                              ? "Approved by"
                                              : "Rejected by"}
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                          <Typography
                                            variant="body2"
                                            className={classes.remarks}
                                          >
                                            {val?.docusignRemarks && val?.docusignRemarks !== '' ?
                                                      `${val?.userName} on ${val?.decisionDate ? moment(val?.decisionDate).format("DD-MMM-YYYY"):' - '} in Docusign (though initially approved in Mosymphony)`
                                                      :`${val?.userName} on ${val?.decisionDate ? moment(val?.decisionDate).format("DD-MMM-YYYY"):' - '}`}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </>
                                  ))}

                              {latestCMOFile &&
                                // latestCMOFile.qaDecision === "" &&
                                latestCMOFile?.approvalDataQAandSME.filter(
                                  (val) =>
                                    val.stakeHolderType === "External" &&
                                    val.requirementType === "Approve" &&
                                    (val.decision === "" ||
                                      val.decision === null)
                                ).length > 0 &&
                                localStorage.collabType === "Pharma Co" &&
                                latestCMOFile?.approvalDataQAandSME
                                  .filter(
                                    (val) =>
                                      val.userId ===
                                        deliverablesData.sponsorQASignatoryID &&
                                      val.stakeHolderType === "External" &&
                                      val.requirementType === "Approve" &&
                                      (val.decision === "" ||
                                        val.decision === null)
                                  )
                                  .map((val) => (
                                    <React.Fragment>
                                      {/* <Grid
                              container
                              spacing={3}
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Grid item xs={4}>
                                  <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Supporting files
                                </Typography>
                              </Grid>


                              {boFiles.length === 0 ? (
                                <Grid item xs={8}>
                                  <Box>
                                    <Dropzone
                                      disabled
                                      // onDrop={(files) => {
                                      //   handleFileUpload(files);
                                      // }}
                                      accept=".csv,.xls,.xlsx,.pdf,.jpeg,.png,.jpg,.bmp,.doc,.docx"
                                    >
                                      {({ getRootProps, getInputProps }) => (
                                        <div
                                          {...getRootProps({
                                            className: "dropzone",
                                            onDrop: (event) =>
                                              event.preventDefault(),
                                          })}
                                          // className={classes.files}
                                          style={{
                                            border: "1px solid #707070",
                                            display: "flex",
                                            alignItems: "center", // Align content vertically
                                            justifyContent: "space-between", // Space out text and icon
                                            //   padding: "10px",
                                          }}
                                        >
                                          <input {...getInputProps()} />

                                          <Typography
                                            variant="body2"
                                            style={{
                                              cursor: "pointer",
                                              paddingLeft: "10px",
                                            }}
                                          >
                                            Drag &amp; drop or click here to
                                            upload files
                                          </Typography>

                                          <PublishIcon
                                            fontSize="large"
                                            style={{
                                              marginLeft: "auto", // Push icon to the right
                                              cursor: "pointer",
                                            }}
                                          />
                                        </div>
                                      )}
                                    </Dropzone>
                                  </Box>
                                </Grid>
                              ) : (
                                <Grid item xs={8} className={classes.fileLink}>
                                  {boFiles.map((file, i) => (
                                    <>
                                      <PublishIcon className={classes.icon} />
                                      <Link
                                        // href={file.fileLink}
                                        target="_blank"
                                        color="secondary"
                                        style={{ cursor: "pointer" }}
                                        // onClick={(e) => {
                                        //   e.preventDefault(); // Prevent default link action
                                        //   handleFileClick(file); // Trigger the state change to open the component
                                        // }}
                                      >
                                        {file.name}
                                      </Link>
                                      <CloseIcon
                                        fontSize="small"
                                        color="error"
                                        style={{
                                          paddingLeft: "0.5rem",
                                          paddingTop: "0.5rem",
                                          cursor: "pointer",
                                          width: "19px",
                                        }}
                                        onClick={() => handleFileDelete(i)}
                                      />
                                    </>
                                  ))}
                                </Grid>
                              )}
                            </Grid> */}
                                      <Grid
                                        container
                                        spacing={3}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Grid item xs={4}>
                                          <Typography
                                            variant="body2"
                                            className={classes.remarks}
                                          >
                                            {/* Approve / Reject Remarks */}
                                            QA Approval
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                          <TextField
                                            placeholder="Enter remarks here"
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            multiline
                                            size="small"
                                            disabled={
                                              val.decisionBy !==
                                                tokenData.email_address ||
                                              (val.decisionBy ===
                                                tokenData.email_address &&
                                                val.enableApprovalFlag ===
                                                  false)
                                            }
                                            value={
                                              val.decisionBy !==
                                                tokenData.email_address ||
                                              (val.decisionBy ===
                                                tokenData.email_address &&
                                                val.enableApprovalFlag ===
                                                  false)
                                                ? ""
                                                : remarks
                                            } // Bind the state to the TextField value
                                            onChange={handleRemarksChange} // Trigger the handler on change
                                            onBlur={(e) => {
                                              const { name, value } = e.target;
                                              // Trim leading and trailing spaces for string values
                                              if (typeof value === "string" && value.trim() !== value) {
                                                handleRemarksChange({ target: { name, value: value.trim() } });
                                              }
                                            }}
                                          />
                                        </Grid>
                                      </Grid>
                                      <Grid
                                        container
                                        spacing={3}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Grid item xs={4}></Grid>
                                        <Grid item xs={8}>
                                          <Grid
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <CustomButton
                                              color="#28A745"
                                              textColor="#fff"
                                              disabled={
                                                val.decisionBy !==
                                                  tokenData.email_address ||
                                                (val.decisionBy ===
                                                  tokenData.email_address &&
                                                  val.enableApprovalFlag ===
                                                    false)
                                              }
                                              onClick={() => {
                                                if (val.eSignatureRequired) {
                                                  handleCMOApproveRejectClick(
                                                    "Approved",
                                                    val.sequenceNumber,
                                                    val
                                                  )
                                                } else if (val.digitalSignatureRequired) {
                                                  getDigitalSigingUrl(val.sequenceNumber,latestCMOFile.collabrixFileID)
                                                  // setDigitalScreen({
                                                  //   openDialogBox: true,
                                                  //   // signingUrl: val.signingUrl
                                                  //   signingUrl: 'https://demo.docusign.net/Signing/MTRedeem/v1/bba66182-881e-4421-8228-8aa44d363fbd?slt=eyJ0eXAiOiJNVCIsImFsZyI6IlJTMjU2Iiwia2lkIjoiNjgxODVmZjEtNGU1MS00Y2U5LWFmMWMtNjg5ODEyMjAzMzE3In0.AQYAAAABAAMABwCAnyHjxBLdSAgAgD8zauYS3UgYAAEAAAAAAAAAIQDsAgAAeyJUb2tlbklkIjoiYzMyZjkwZDAtOGYyMy00MzZhLWFlNTctN2Q1MDgxZGRkZjAxIiwiRXhwaXJhdGlvbiI6IjIwMjQtMTItMDJUMTE6MzY6MzkrMDA6MDAiLCJJc3N1ZWRBdCI6IjIwMjQtMTItMDJUMTE6MzE6MzkuMTU1NjM3NSswMDowMCIsIlJlc291cmNlSWQiOiJjMDJhOTI0OS00NjExLTRkYTUtYTVjYi1kNWU5NzkwMWJjNjIiLCJSZXNvdXJjZXMiOiJ7XCJFbnZlbG9wZUlkXCI6XCJjMDJhOTI0OS00NjExLTRkYTUtYTVjYi1kNWU5NzkwMWJjNjJcIixcIkFjdG9yVXNlcklkXCI6XCIyYmNkZGM1Yi1iZDg2LTRhZGEtYmIyMy1mNGUzOGU3MGQ0NTBcIixcIlJlY2lwaWVudElkXCI6XCI0ZDQwNDNkMC1hZGFmLTQwMDAtYjc0OC1hYjg5ODgzMTBiMDZcIixcIkZha2VRdWVyeVN0cmluZ1wiOlwidD02YWRlNGY1YS0xNzcyLTRmNzctYmM2OS0xNjUwMjc1MDEyNmZcIixcIkludGVncmF0b3JLZXlcIjpcImY0M2RlN2JkLWZjZDgtNGExZS05YTY2LTFiMzFhYTZlYWNjMlwiLFwiQ3JlYXRlZEF0XCI6XCIyMDI0LTEyLTAyVDExOjMxOjM5LjE0ODYzNTlaXCJ9IiwiVG9rZW5UeXBlIjoxLCJBdWRpZW5jZSI6IjI1ZTA5Mzk4LTAzNDQtNDkwYy04ZTUzLTNhYjJjYTU2MjdiZiIsIlJlZGlyZWN0VXJpIjoiaHR0cHM6Ly9kZW1vLmRvY3VzaWduLm5ldC9TaWduaW5nL1N0YXJ0SW5TZXNzaW9uLmFzcHgiLCJIYXNoQWxnb3JpdGhtIjowLCJIYXNoUm91bmRzIjowLCJUb2tlblN0YXR1cyI6MCwiSXNTaW5nbGVVc2UiOmZhbHNlfT8AAGdZlcUS3Ug.D4EteV3mpOHS1tHzwvBZlXSpx6jfsSGTXXpCnfV4dzAk252liAHLndFgEqlipx2992UORt-NG4031BjFRc06L_oYJ_MvGxGrotopXR41TtJjV4lBoqpoCfh6IStEtbyC8tDl88N5Y2i8OO2YwA66I5mxMXvbvhApFBkrbA56dNSYQU0EwxU0VTinlGtrBf8FKr17JdbHAKFVczsNpxu5UWp7hEf2WqIPD1W2kFfkL1fyrKsWg2aHwcbpPWBf5CkGEXeGtC8tnIyvNa3www2hQJcEvsYtNSQwlhaTeVZybgqiBgCHohx7tCxMhP31BEwS-uDx0s6TQpzLgZVPmc7rDw'
                                                  // })
                                                  setDigiSignDialogBox({
                                                    ...openDigiSignDialogBox,
                                                    digitalSignObj:
                                                    {
                                                      type: "Approved",
                                                      value: val
                                                      }
                                                  })
                                                } else {
                                                  handleCMOApproveRejectClick(
                                                    "Approved",
                                                    val.sequenceNumber,
                                                    val
                                                  )
                                                }
                                              }
                                              }
                                              // onClick={() => handleCMOApproveRejectClick("Approved")}
                                            >
                                              Approve
                                            </CustomButton>

                                            <CustomButton
                                              color="#DC3545"
                                              textColor="#fff"
                                              disabled={
                                                val.decisionBy !==
                                                  tokenData.email_address ||
                                                (val.decisionBy ===
                                                  tokenData.email_address &&
                                                  val.enableApprovalFlag ===
                                                    false)
                                              }
                                              onClick={() =>{
                                                if (val.eSignatureRequired) {
                                                  // handleCMOApproveRejectClick(
                                                  //   "Rejected",
                                                  //   val.sequenceNumber,
                                                  //   val
                                                  // )
                                                  setDigiSignDialogBox({
                                                    ...openDigiSignDialogBox,
                                                    openDialogBox: true,
                                                    dialogBoxType: 'success',
                                                    digitalSignObj:
                                                    {
                                                      type: "Rejected",
                                                      value: val
                                                      }
                                                  })
                                                } else if (val.digitalSignatureRequired) {
                                                  // handleCMOApproveRejectClick(
                                                  //   "Rejected",
                                                  //   val.sequenceNumber,
                                                  //   val
                                                  // )
                                                  // getDigitalSigingUrl(val.sequenceNumber,latestCMOFile.collabrixFileID)
                                                  // setDigiSignDialogBox({
                                                  //   ...openDigiSignDialogBox,
                                                  //   digitalSignObj:
                                                  //   {
                                                  //     type: "Rejected",
                                                  //     value: val
                                                  //     }
                                                  // })
                                                  setDigiSignDialogBox({
                                                    ...openDigiSignDialogBox,
                                                    openDialogBox: true,
                                                    dialogBoxType: 'success',
                                                    digitalSignObj:
                                                    {
                                                      type: "Rejected",
                                                      value: val
                                                      }
                                                  })
                                                } else {
                                                  // handleCMOApproveRejectClick(
                                                  //   "Rejected",
                                                  //   val.sequenceNumber,
                                                  //   val
                                                  // )
                                                  setDigiSignDialogBox({
                                                    ...openDigiSignDialogBox,
                                                    openDialogBox: true,
                                                    dialogBoxType: 'success',
                                                    digitalSignObj:
                                                    {
                                                      type: "Rejected",
                                                      value: val
                                                      }
                                                  })
                                                }
                                              }
                                              }
                                              // onClick={() => handleCMOApproveRejectClick("Rejected")}
                                            >
                                              Reject
                                            </CustomButton>
                                            <CustomButton
                                              color="#F26336" // Custom orange background
                                              hoverColor="#D8542E" // Darker orange on hover
                                              textColor="#fff"
                                              disabled
                                            >
                                              Remind CMO Team
                                            </CustomButton>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </React.Fragment>
                                  ))}

                              {/* {latestCMOFile &&
                             latestCMOFile?.approvalDataQAandSME.filter((val)=>  val.stakeHolderType === "External" && val.requirementType === "Approve" && (val.decision==='' ||val.decision===null )).length > 0 &&
                            localStorage.collabType === "Pharma Co" &&
                            <>
                            {latestCMOFile?.approvalDataQAandSME.filter((val) =>  val.stakeHolderType === "External" && val.userId === deliverablesData.sponsorQASignatoryID && val.requirementType === "Approve" && (val.decision === '' || val.decision === null)).map((val) => (
                              val.decisionBy === tokenData.email_address && val.enableApprovalFlag === true ?
                                <></>
                                :
                                
                              <Grid container spacing={3}>
                              <Grid item xs={4}>
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  {val.requirementType === "Approve" ? 'Approval':'Review'}
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                  >
                                    {val.enableApprovalFlag ? `Assigned to ${val.userName} ( ${val.userRole} )`:`To be assigned to ${val.userName} ( ${val.userRole} )`}
                                </Typography>
                              </Grid>
                                  </Grid>
                            ))
                            
                      }

                            </>} */}
                            </>
                          )}

                        {/* </Grid> */}
                      </Paper>
                    </Grid>
                  )}
                </Grid>
              </Box>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                  height: "100px", // Optional: Set a height to vertically center the loader
                  width: "100%",
                }}
              >
                <Typography style={{ textAlign: "center" }}>
                  No Records Found.
                </Typography>
              </div>
            )}
          </Collapse>
        </TableCell>
      </TableRow>

      {isDialogOpen && (
        <FileViewer
          openFileView={isDialogOpen}
          file={selectedFile}
          handleFileViewClose={handleCloseDialog}
          row={row}
          deliverablesData={deliverablesData}
          workItemDetails={workItemDetails}
          sponsorFileDetails={sponsorFileDetails}
          cdmoFileDetails={cdmoFileDetails}
          supportingFiles={supportingFiles}
          sponsorOrgID={deliverablesData?.sponsorOrgID}
          cdmoOrgID={deliverablesData?.cdmoOrgID}
        />
      )}

{/* {viewVersionHistoryScreen && (
        <VersionHistory
          viewVersionHistoryScreen={viewVersionHistoryScreen}
          handleViewVersionHistory={handleViewVersionHistory}
          deliverablesData={deliverablesData}
          cdmoFileDetails={cdmoFileDetails}
          handleFileClick={handleFileClick}
        />
      )} */}

{digitalSignScreen.openDialogBox && digitalSignScreen.signingUrl !=='' &&
    <DigitalSignPopupComponent url={digitalSignScreen.signingUrl}
    openDialog={digitalSignScreen.openDialogBox}
    handleCloseScreen={handleCloseZohoScreen}
    handleDigitalSignatureResponsePopup={handleDigitalSignatureResponsePopup} />
      }

      {openDigiSignDialogBox.openDialogBox &&
        <Dialog open={openDigiSignDialogBox.openDialogBox} maxWidth="sm" fullWidth style={{ borderRadius: '14px' }}
        disableBackdropClick // Disable closing on outside click
          disableEscapeKeyDown // Disable closing on escape key
        >
          <DialogContent className={classes.dialogContent}>
            {digitalSignScreen.envelopeId === '' && openDigiSignDialogBox.dialogBoxType === 'success' && openDigiSignDialogBox.digitalSignObj.type === "Rejected" &&
            <Grid container justifyContent='flex-end'>
            <Typography
              variant='body2'
              style={{
                fontSize: '1rem',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
              }}
                  onClick={() => {
                    setDigiSignDialogBox({
                      openDialogBox: false,
                      dialogBoxType: '',
                      digitalSignObj: null,
                    })
              }}
            >
              Close <CloseIcon fontSize='large' />
            </Typography>
          </Grid>
            }
          
            <>
            {openDigiSignDialogBox.dialogBoxType === 'success' && openDigiSignDialogBox.digitalSignObj.type === "Approved" ? <CheckCircleIcon className={classes.avatar} />:<WarningIcon style={{fontSize: '5rem',color: '#F00',}}/>}
              <Typography
                style={{
                  marginTop: "10px",
                  fontWeight: "600",
                                    color: "black",
                  fontSize:'2rem'
                }}
              >
                {openDigiSignDialogBox.dialogBoxType ==='success' && openDigiSignDialogBox.digitalSignObj.type === "Approved" ? 'Digital Signature Applied Successfully': openDigiSignDialogBox.dialogBoxType ==='success' && openDigiSignDialogBox.digitalSignObj.type === "Rejected" ? 'Reject the document':'Something went wrong. Try again.'}
                            </Typography>
              <DialogActions className={classes.dialogActions}>
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ChevronRight />}
                  style={{
                    borderRadius: "20px",
                    textTransform: "none",
                  }}
                onClick={() => {
                  if (openDigiSignDialogBox.dialogBoxType === 'failed') {
                    //console.log(openDigiSignDialogBox)
                      setDigiSignDialogBox({
                        openDialogBox: false,
                        dialogBoxType: '',
                        digitalSignObj: null,
                      })
                  } else if (openDigiSignDialogBox.dialogBoxType ==='success') {
                    handleCMOApproveRejectClick(
                      openDigiSignDialogBox.digitalSignObj.type,
                      openDigiSignDialogBox.digitalSignObj.value.sequenceNumber,
                      openDigiSignDialogBox.digitalSignObj.value,
                      digitalSignScreen.envelopeId
                    )
                  }
                  }}
              >
                {openDigiSignDialogBox.dialogBoxType === 'failed' ? 'Ok': openDigiSignDialogBox.digitalSignObj.type === "Approved" ? 'Approve the document': 'Reject the document'  }
                </Button>
              </DialogActions>
            </>
          </DialogContent>
        </Dialog>
        }
      
    </>
  );
};

export default CollapsibleRow;
